import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ChaveValor } from '../models/chave-valor.model';

@Injectable({
  providedIn: 'root'
})
export class OrgaoEmissorRgService {

  constructor(public http: HttpClient) { }

  getOrgaoEmissorRG(): Observable<ChaveValor[]> {
    return this.http.get<ChaveValor[]>('assets/server/orgao-emissor-rg.json');
  }

}
